// extracted by mini-css-extract-plugin
module.exports = {"btnOutline":"Button_btnOutline__1PUCQ","button":"Button_button__1U9p5"};